import 'whatwg-fetch';

export default self.fetch.bind(self); // eslint-disable-line no-restricted-globals
export const Headers = self.Headers; // eslint-disable-line no-restricted-globals
export const Request = self.Request; // eslint-disable-line no-restricted-globals
export const Response = self.Response; // eslint-disable-line no-restricted-globals
